import React from "react";
import Directions from "../../home/directions/Directions";

const BakalavrDirections = () => {
  return <Directions titleOverride={"Bakalavr yo'nalishlari"} endpoint={"/api/directions/bachelors/"} filterLevel={"bachelor"} />;
};

export default BakalavrDirections; 